import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { colspan: "3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, null, -1)

import { useLeaveStore } from '@/stores/leave'
import RegulationRow from '@/components/RegulationRow.vue'
import { translate } from '@/helpers/translate'


export default /*#__PURE__*/_defineComponent({
  __name: 'DaysUsage',
  setup(__props) {

const leaveStore = useLeaveStore()
const { t } = translate()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("h2", {
          class: _normalizeClass(_ctx.$style.title)
        }, _toDisplayString(_unref(t)('regulationsTitle')), 3)
      ])
    ]),
    _createElementVNode("tr", null, [
      _hoisted_2,
      _createElementVNode("th", {
        class: _normalizeClass(_ctx.$style.column2)
      }, _toDisplayString(_unref(t)('regulationsThMom')), 3),
      _createElementVNode("th", {
        class: _normalizeClass(_ctx.$style.column2)
      }, _toDisplayString(_unref(t)('regulationsThPartner')), 3)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leaveStore).regulations, (regulation) => {
      return (_openBlock(), _createBlock(RegulationRow, { regulation: regulation }, null, 8, ["regulation"]))
    }), 256)),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_unref(t)('regulationsTotalDaysOff')), 1),
      _createElementVNode("td", {
        class: _normalizeClass({[_ctx.$style.maxedOut]: _unref(leaveStore).totalDaysUsed(true) > _unref(leaveStore).totalDaysOffAvailableMom })
      }, _toDisplayString(_unref(leaveStore).totalDaysUsed(true)) + " / " + _toDisplayString(_unref(leaveStore).totalDaysOffAvailableMom), 3),
      _createElementVNode("td", {
        class: _normalizeClass({[_ctx.$style.maxedOut]: _unref(leaveStore).totalDaysUsed(false) > _unref(leaveStore).totalDaysOffAvailablePartner })
      }, _toDisplayString(_unref(leaveStore).totalDaysUsed(false)) + " / " + _toDisplayString(_unref(leaveStore).totalDaysOffAvailablePartner), 3)
    ])
  ], 64))
}
}

})